import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\DeleteMediaFromElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DeleteMediaFromElectronicSignatureController.php
* @route '/api/electronic-signature/{electronicSignature}/media/{media}'
*/
const DeleteMediaFromElectronicSignatureController = (args: { electronicSignature: string | number | { id: string | number }, media: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteMediaFromElectronicSignatureController.url(args, options),
    method: 'delete',
})

DeleteMediaFromElectronicSignatureController.definition = {
    methods: ["delete"],
    url: '/api/electronic-signature/{electronicSignature}/media/{media}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\DeleteMediaFromElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DeleteMediaFromElectronicSignatureController.php
* @route '/api/electronic-signature/{electronicSignature}/media/{media}'
*/
DeleteMediaFromElectronicSignatureController.url = (args: { electronicSignature: string | number | { id: string | number }, media: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
            media: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return DeleteMediaFromElectronicSignatureController.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\DeleteMediaFromElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DeleteMediaFromElectronicSignatureController.php
* @route '/api/electronic-signature/{electronicSignature}/media/{media}'
*/
DeleteMediaFromElectronicSignatureController.delete = (args: { electronicSignature: string | number | { id: string | number }, media: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteMediaFromElectronicSignatureController.url(args, options),
    method: 'delete',
})

export default DeleteMediaFromElectronicSignatureController